import clsx from "clsx";

import { Spinner } from "./spinner";

export const LoadingIndicator = () => {
  return (
    <div
      className={clsx(
        "w-[52px] h-[52px] rounded-full bg-v2-primary shadow-[0_0_20px] shadow-v2-black/10%",
        "flex items-center justify-center",
      )}
    >
      <Spinner />
    </div>
  );
};
